/* eslint-disable */
import { getToken, removeToken, removeUserInfo } from '@/utils/auth'
import { getMenuList, getShopType } from '@/api/user'
import { Message } from 'element-ui'

let buttons = {}
const user = {
    state: {
        token: getToken(),
        currentUser: {},
        currentMenu: [],
        buttons: {},
        shopType: '' // 1 O2O 2 B2C
    },

    mutations: {
        // 设置token
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        // 设置用户
        SET_USER: (state, userInfo) => {
            state.currentUser = userInfo
        },
        // 设置菜单
        SET_MENU: (state, menuInfo) => {
            state.currentMenu = menuInfo
        },
        // 设置按钮权限
        SET_BUTTONS: (state, buttons) => {
            state.buttons = buttons
        },
        // 设置当前商家类型
        SET_SHOP_TYPE: (state, payload) => {
            state.shopType = payload
        }
    },

    actions: {
        // 获取用户信息
        GetUserInfo({ commit }) {
            return new Promise((resolve, reject) => {
                // getCurrentInfo()
                //     .then(res => {
                //         if (res.code === 200) {
                //             commit('SET_USER', res.data.currentUserDTO)
                //             commit('SET_MENU', res.data.resourcesListTreeList)
                //             resolve(res)
                //         } else {
                //             reject(res.message || '获取用户信息异常')
                //         }
                //     })
                //     .catch(error => {
                //         reject(error)
                //     })
            })
        },
        // 存储用户信息
        SetUserInfo({ commit }, userInfo) {
            commit('SET_USER', userInfo)
        },
        // 获取菜单
        async GetMenu({ commit }, params) {
            const { code, data, msg } = await getMenuList(params)
            if (+code === 0) {
                // commit('SET_MENU', formatMenus(data))
                formatButtons(data) // 没用上！
                return formatMenus(data)
            } else {
                Message.error(msg || '请求失败')
            }
        },
        // 获取店铺类型
        async GetShopType({ commit }, params) {
            const { code, data, msg } = await getShopType(params)
            if (+code === 0) {
                let type = ''
                Object.keys(data).map(key => {
                    return (type = data[key])
                })
                commit('SET_SHOP_TYPE', type)
            } else {
                Message.error(msg || '请求失败')
            }
        },

        // 登出
        LogOut({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', '')
                commit('SET_USER', {})
                removeToken()
                removeUserInfo()
                resolve()
                // doLogout()
                //     .then(res => {
                //         if (res.code === 200) {
                //             commit('SET_TOKEN', '')
                //             commit('SET_USER', {})
                //             removeToken()
                //             resolve()
                //             // reset visited views and cached views
                //             // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
                //             dispatch('delAllViews', null, { root: true })
                //         } else {
                //             reject(res.message || '退出异常')
                //         }
                //     })
                //     .catch(error => {
                //         reject(error)
                //     })
            })
        }
    }
}

const formatMenus = menus => {
    let tempMenu = []
    tempMenu = menus.map(menu => {
        let child = []

        if (menu.children && menu.children.length) {
            child = formatMenus(menu.children)
        }
        return {
            name: menu.name || '',
            path: menu.path || '/' + menu.name,
            id: menu.id,
            target: menu.target,
            hidden: menu.hidden,
            meta: { title: menu.title, icon: menu.icon },
            children: child
        }
    })
    return tempMenu
}

const formatButtons = menus => {
    menus.map(menu => {
        if (menu && menu.hidden) {
            buttons = {
                ...buttons,
                [menu.path + '']: menu.pid
            }
        }
        if (menu.children && menu.children.length) {
            formatButtons(menu.children)
        }
    })
}
export default user
